/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { ChangeEvent, useEffect, useState } from 'react';
import IconTooltip from 'components/molecules/IconTooltip';
import moment from 'moment';
import SalesBudgetMonthDomain, {
  BudgetDailyItemData,
  BudgetType,
  BusinessStatus,
} from 'domain/master/storeManagement/salesBudgetDailyInput';
import { SalesBudgetMonthType } from 'components/organismos/master/storeManagement/salesBudgetYear/SalesBudgetDailyInputLayout/type';
import AccordionRow from 'components/molecules/AccordionRow';
import MinusSquare from 'assets/icon/minusSquare';
import PlusSquare from 'assets/icon/plusSquare';
import {
  formatterPercent,
  getWeekDayStyle,
  showExpensesClassificationText,
} from 'components/organismos/master/storeManagement/salesBudgetYear/util';
import { gridCol, utilityColor } from 'components/styles';
import { isMacOs } from 'react-device-detect';
import BodyText from 'components/atoms/BodyText';

type Props = {
  formik: any;
  getRows: SalesBudgetMonthType;
  handleChangeSelect: (index: number) => void;
  calcSalesRatioValues: (listSumOfAdvertisingSaleAndSaleBudgetFree: number[]) => void;
  calcLtSalesDailyValues: (targetIndex: number) => void;
  calcLtCostDailyValues: (targetIndex: number) => void;
  calcLtLaborDailyValues: (targetIndex: number) => void;
  calcLtAdvertisingDailyValues: (targetIndex: number) => void;
  calcLtRentDailyValues: (targetIndex: number) => void;
  calcLtExpensesDailyValues: (targetIndex: number) => void;
  calcLtOtherDailyValues: (targetIndex: number) => void;
  calcLtCustomPriceDailyValues: () => void;
  calcLtSalesMonthlyValue: (targetIndex: number) => void;
  calcLtCostMonthlyValue: (targetIndex: number) => void;
  calcLtLaborMonthlyValue: (targetIndex: number) => void;
  calcLtAdvertisingMonthlyValue: (targetIndex: number) => void;
  calcLtRentMonthlyValue: (targetIndex: number) => void;
  calcLtExpensesMonthlyValue: (targetIndex: number) => void;
  calcLtOtherMonthlyValue: (targetIndex: number) => void;
  calcLtCustomPriceMonthlyValue: () => void;
};

const LabelRow = ({
  id,
  color,
  label,
  isExpanded,
  handleClick,
}: {
  id: string;
  color: 'lightOrange' | 'lightBlue';
  label: string;
  isExpanded: boolean;
  handleClick: () => void;
}) => (
  <tr onClick={handleClick}>
    <td
      style={{
        borderRight: 'none',
      }}
      className={`text-left active p-left ${color}`}
      colSpan={3}
    >
      {label}
    </td>
    <td
      className={`text-right p-left ${color}`}
      style={{
        borderLeft: 'none',
      }}
      colSpan={1}
    >
      {isExpanded ? <MinusSquare /> : <PlusSquare />}
    </td>
    <td style={{ width: '34px' }} className="column_change text-center" />
    <td style={{ width: '99px' }} className="text-right active">
      <span id={id} />
    </td>
  </tr>
);

const TotalRow = ({
  id,
  color,
  label,
  value,
  handleCalculate,
}: {
  id: string;
  color: 'lightOrange' | 'lightBlue';
  label: string;
  value: number;
  handleCalculate?: () => void;
}) => {
  useEffect(() => {
    if (handleCalculate) {
      handleCalculate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <tr>
      <td className={`text-center active ${color}`} colSpan={4}>
        <label className="control-label">{label}</label>
      </td>
      <td className={color} colSpan={1} />
      <td className={`text-right active ${color}`} colSpan={1}>
        <span
          style={{
            whiteSpace: 'normal',
            display: 'inline-block',
            maxWidth: '95px',
            overflowWrap: 'break-word',
          }}
          id={id}
        >
          {value.toLocaleString()}
        </span>
      </td>
    </tr>
  );
};

const PercentRow = ({ id, label, value }: { id: string; label: string; value: number }) => (
  <tr>
    <td className="text-right active p-right" colSpan={4}>
      <label className="control-label">{label}</label>
    </td>
    <td colSpan={1} className="column_change text-center" />
    <td className="text-right active " colSpan={1}>
      <span id={id}>{formatterPercent.format(value)}</span>
    </td>
  </tr>
);

const InputCell = ({
  id,
  value,
  hasError,
  disabled,
  onChange,
}: {
  id: string;
  hasError: boolean;
  value: number | undefined;
  disabled: boolean;
  onChange: (id: string, value: number) => void;
}) => {
  const [inputValue, setInputValue] = useState(value?.toLocaleString());

  useEffect(() => setInputValue(value?.toLocaleString()), [value]);

  const handleFocus = (event: React.MouseEvent<HTMLInputElement>) => {
    event.currentTarget.select();
  };

  return (
    <>
      {disabled ? (
        <span
          className="text-right"
          style={{
            whiteSpace: 'normal',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            // maxWidth: '95px',
            height: '32px',
            overflowWrap: 'break-word',
          }}
          id={id}
        >
          {inputValue}
        </span>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <input
            className="text-right"
            style={{
              width: '85%',
              maxWidth: '95px',
              height: '26px',
              marginRight: 0,
              border: hasError ? `1px solid ${utilityColor.error}` : undefined,
            }}
            value={inputValue}
            id={id}
            onClick={handleFocus}
            onChange={(e) => {
              let removed = Number(e.target.value.replace(/,/g, ''));

              // 数値以外が入力された場合は0にする
              if (isNaN(removed)) {
                removed = 0;
              }

              setInputValue(removed.toLocaleString());
              onChange(id, removed);
            }}
          />
        </div>
      )}
    </>
  );
};

const TableSalesPlanDaily = ({
  formik,
  getRows,
  handleChangeSelect,
  calcSalesRatioValues,
  calcLtSalesDailyValues,
  calcLtCostDailyValues,
  calcLtLaborDailyValues,
  calcLtAdvertisingDailyValues,
  calcLtRentDailyValues,
  calcLtExpensesDailyValues,
  calcLtOtherDailyValues,
  calcLtCustomPriceDailyValues,
  calcLtSalesMonthlyValue,
  calcLtCostMonthlyValue,
  calcLtLaborMonthlyValue,
  calcLtAdvertisingMonthlyValue,
  calcLtRentMonthlyValue,
  calcLtExpensesMonthlyValue,
  calcLtOtherMonthlyValue,
  calcLtCustomPriceMonthlyValue,
}: Props) => {
  const [checkScrollBar, setCheckScrollBar] = useState(0);

  const { setFieldValue } = formik;
  const {
    listSumOfAdvertisingSaleAndSaleBudgetFree,
    listSumOfOtherTotalCost,
    listSumOfOtherTotalCostRate,
    listSumOfEmployeeLaborCostAndPartLaborCost,
    listSumOfFoodCostAndDrinkCost,
    listSumOfAdvertisingExpenseEachDay,
    listOfOperatingIncome,
    listOfRateOperatingIncome,
    listNumberOfCustomers,
    listOfTurnoverRate,
    listOfMarginalProfit,
    listRateOfMarginalProfit,
    listOfContributionMargin,
    listOfRateContributionMargin,
    listOfBreakEventPointSale,
    listOfBreakEventPointNumber,
    listSumOfEmployeeAndPartCostRatio,
    listOfLaborShare,
    listOfFLACost,
    listOfFLACostRate,
    listOfProfitLossCost,
    listOfProfitLossCostRate,
    listOfFLAROCost,
    listOfFLAROCostRate,
    listSumOfRentEachDay,
    sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow,
    sumOfTotalEmployeeLaborCostAndPartLaborCost,
    sumOfAdvertisingExpense,
    sumOfLandRentRow,
    sumOfFoodCostAndDrinkCost,
    sumOfNumberOfCustomers,
    sumOfTurnoverRate,
    sumOfMarginalProfit,
    sumOfRateMarginalProfit,
    sumOfContributionMargin,
    sumOfRateContributionMargin,
    sumOfBreakEventPointSale,
    sumOfBreakEventPointNumber,
    sumOfSumOfEmployeeAndPartCostRatio,
    sumOfLaborShare,
    sumOfFLACostRate,
    sumOfFLAROCost,
    sumOfFLACost,
    sumOfProfitLossCost,
    sumOfProfitLossCostRate,
    sumOfOtherTotalCost,
    sumOfOtherTotalCostRate,
    totalOfOperatingIncome,
    rateOfOperationIncome,
  } = getRows;

  const {
    salesPlanDailyDateData,
    monthLtSales,
    monthLtCost,
    monthLtLabor,
    monthLtAdvertising,
    monthLtRent,
    monthLtExpenses,
    monthLtOther,
    monthLtCustomPrice,
  } = formik.values as SalesBudgetMonthDomain;

  const eventScroll = (e: { target: any }) => {
    const { target } = e;
    const contentRight = document.getElementById('contentRight');
    const contentRight2 = document.getElementById('contentRight2');
    const headRight = document.getElementById('headRight');
    const scrollBottom = document.getElementById('scrollBottom');
    if (e.target.type !== 'text') {
      if (contentRight) {
        contentRight.scrollLeft = target.scrollLeft;
      }
      if (contentRight2) {
        contentRight2.scrollLeft = target.scrollLeft;
      }
      if (headRight) {
        headRight.scrollLeft = target.scrollLeft;
      }

      if (scrollBottom) {
        scrollBottom.scrollLeft = target.scrollLeft;
      }
    }
  };

  const dateSelectType = (e: ChangeEvent<HTMLSelectElement>, index: number) => {
    const { target } = e;
    setFieldValue(target.id, Number(target.value));
    handleChangeSelect(index);
  };

  const calcHeadRightWidth = () => {
    if (!isMacOs) return 'calc(100% - 350px)';

    return checkScrollBar ? 'calc(100% - 335px)' : 'calc(100% - 350px)';
  };

  // Accordion for 売上高
  const [isAdvertisingSaleDataExpanded, setIsAdvertisingSaleDataExpand] = useState(true);
  // Accordion for F（食材費）
  const [isIngredientCostExpanded, setIsIngredientCostExpand] = useState(true);
  // Accordion for L（人件費）
  const [isLaborCostExpanded, setIsLaborCostExpand] = useState(true);
  // Accordion for A（広告費）
  const [isAdvertisingCostExpanded, setIsAdvertisingCostExpand] = useState(true);
  // Accordion for R（家賃）
  const [isRentExpanded, setIsRentExpand] = useState(true);
  // Accordion for O（その他経費）
  const [isOtherExpensesExpanded, setIsOtherExpensesExpand] = useState(true);

  useEffect(() => {
    const offsetWidth = document.getElementById('wrapTblContent')?.offsetWidth || 0;
    const clientWidth = document.getElementById('wrapTblContent')?.offsetWidth || 0;
    if (offsetWidth - clientWidth === 0) {
      setCheckScrollBar(1);
    } else {
      setCheckScrollBar(0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rightTableWidth = salesPlanDailyDateData.length * 106;

  return (
    <div className="wrap-budget">
      {Object.keys(formik.errors).map((key) => (
        <>
          {formik.errors[key].map((item: any) => (
            <>
              {Object.keys(item).map((itemKey) => (
                <div key={item[itemKey]}>
                  <BodyText color={utilityColor.error}>{item[itemKey]}</BodyText>
                </div>
              ))}
            </>
          ))}
        </>
      ))}
      {/* ステータス table header */}
      <div
        className="sales_plan_daily-settings__top"
        style={{
          display: 'flex',
          marginRight: !isMacOs && checkScrollBar ? '2px' : '0',
        }}
      >
        <div
          style={{
            width: '350px',
            borderRight: '5px solid #d2d6de',
          }}
        >
          <table
            className="table table-bordered table-striped table-condensed text-nowrap"
            style={{ width: gridCol.grid12 }}
          >
            <tbody>
              <tr
                style={{
                  height: '48px',
                }}
              >
                <td className="text-center active" colSpan={7}>
                  ステータス
                </td>
              </tr>
              <tr
                style={{
                  height: '67px',
                }}
              >
                <td className="text-center active">項目</td>
                <td className="text-center active" style={{ width: '38px' }}>
                  固変
                </td>
                <td className="text-center active" style={{ width: '105px' }}>
                  合計
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          className="layout_sale_right"
          id="headRight"
          style={{
            width: calcHeadRightWidth(),
          }}
          onScroll={eventScroll}
        >
          <div
            className="table-responsive no-padding layout-sale-right"
            id="daily_layout_sale_right"
            style={{
              width: `${rightTableWidth}px`,
              marginRight: '15px',
            }}
          >
            <table
              className="table table-bordered table-striped table-condensed text-nowrap"
              style={{ width: `${rightTableWidth}px` }}
            >
              <thead>
                <tr>
                  {salesPlanDailyDateData.map((data, index) => (
                    <th key={`salesPlanDailyDateData.[${index}]`} className="text-center ">
                      <select
                        id={`salesPlanDailyDateData[${index}].status`}
                        className="form-control input-ms date-select-type"
                        onChange={(e) => dateSelectType(e, index)}
                      >
                        <option value={BusinessStatus.Open.toString()} selected={data.status === BusinessStatus.Open}>
                          営業
                        </option>
                        <option
                          value={BusinessStatus.Closed.toString()}
                          selected={data.status === BusinessStatus.Closed}
                        >
                          定休
                        </option>
                      </select>
                    </th>
                  ))}
                </tr>
                <tr>
                  {salesPlanDailyDateData.map((date, index) => (
                    <th key={`weekday_date_${index}`} className={getWeekDayStyle(date.weekday)}>
                      {moment(date.day, 'YYYY-MM-DD').format('DD')}
                    </th>
                  ))}
                </tr>
                <tr>
                  {salesPlanDailyDateData.map((date, index) => (
                    <th key={`weekday_${index}`} className={getWeekDayStyle(date.weekday)}>
                      {date.weekday}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
      <div />
      {/* ステータス table header */}

      {/* Table Body */}
      <div
        className="table-content"
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: gridCol.grid12,
          height: 'calc(100dvh - 300px)',
        }}
      >
        {/* First Table */}
        <div
          style={{
            display: 'inline-flex',
            width: gridCol.grid12,
          }}
          id="wrapTblContent"
        >
          {/* Table Left */}
          <div className="contentLeft" style={{ width: '350px', borderRight: '5px solid rgb(210, 214, 222)' }}>
            <table className="table table-bordered table-striped table-condensed text-nowrap">
              <tbody>
                {/* Table Top  */}
                {/* Start 売上高 */}
                <AccordionRow
                  isExpanded={isAdvertisingSaleDataExpanded}
                  trigger={
                    <LabelRow
                      label="売上高"
                      isExpanded={isAdvertisingSaleDataExpanded}
                      handleClick={() => setIsAdvertisingSaleDataExpand((prev) => !prev)}
                      color="lightOrange"
                      id="sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow"
                    />
                  }
                >
                  {monthLtSales?.map((data, index) => (
                    <tr key={`monthLtSales[${index}]`}>
                      <td colSpan={1} className="empty_column lightOrange" />
                      <td className="text-right active p-right" colSpan={3}>
                        <label className="control-label">{data.analyticalItemName}</label>
                      </td>
                      <td colSpan={1} />
                      <td colSpan={1} className="text-right active width-110">
                        <InputCell
                          id={`monthLtSales[${index}].dayTotal`}
                          value={data.dayTotal}
                          disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                          hasError={!!formik.errors.monthLtSales?.[index]?.dayTotal}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtSalesDailyValues(index);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </AccordionRow>
                <TotalRow
                  label="合計"
                  id="saleBudgetMonthData03"
                  color="lightOrange"
                  value={sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow}
                  handleCalculate={() => calcSalesRatioValues(listSumOfAdvertisingSaleAndSaleBudgetFree)}
                />

                {/* End 売上高 */}
                {/* Start F（食材費） */}
                <AccordionRow
                  isExpanded={isIngredientCostExpanded}
                  trigger={
                    <LabelRow
                      label="F（食材費）"
                      isExpanded={isIngredientCostExpanded}
                      handleClick={() => setIsIngredientCostExpand((prev) => !prev)}
                      color="lightBlue"
                      id="sumOfTotalFoodCostAndDrinkCost"
                    />
                  }
                >
                  {monthLtCost?.map((data, index) => (
                    <tr key={data.analyticalItemCode}>
                      <td colSpan={1} className="empty_column lightBlue" />
                      <td className="text-right active p-right" colSpan={3}>
                        <label className="control-label">{data.analyticalItemName}</label>
                      </td>
                      <td colSpan={1} className="column_change text-center">
                        {showExpensesClassificationText(data.expensesClassification)}
                      </td>
                      <td colSpan={1} className="text-right active width-110">
                        <InputCell
                          id={`monthLtCost[${index}].dayTotal`}
                          value={data.dayTotal}
                          hasError={formik.errors.monthLtCost?.[index]?.dayTotal}
                          disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtCostDailyValues(index);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </AccordionRow>

                <TotalRow
                  label="【F】計"
                  id="saleBudgetMonthData03"
                  color="lightBlue"
                  value={sumOfFoodCostAndDrinkCost}
                />

                <PercentRow
                  id="saleBudgetMonthData03"
                  label="F率"
                  value={
                    sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow > 0
                      ? sumOfFoodCostAndDrinkCost / sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow
                      : 0
                  }
                />

                {/* End F（食材費） */}
                {/* Start L（人件費） */}

                <AccordionRow
                  isExpanded={isLaborCostExpanded}
                  trigger={
                    <LabelRow
                      label="L（人件費）"
                      isExpanded={isLaborCostExpanded}
                      handleClick={() => setIsLaborCostExpand((prev) => !prev)}
                      color="lightBlue"
                      id="sumOfTotalFoodCostAndDrinkCost"
                    />
                  }
                >
                  {monthLtLabor?.map((data, index) => (
                    <tr key={data.analyticalItemCode}>
                      <td colSpan={1} className="empty_column lightBlue" />
                      <td className="text-right active p-right" colSpan={3}>
                        <label className="control-label">{data.analyticalItemName}</label>
                      </td>
                      <td colSpan={1} className="column_change text-center">
                        {showExpensesClassificationText(data.expensesClassification)}
                      </td>
                      <td colSpan={1} className="text-right active width-110">
                        <InputCell
                          id={`monthLtLabor[${index}].dayTotal`}
                          value={data.dayTotal}
                          hasError={formik.errors.monthLtLabor?.[index]?.dayTotal}
                          disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtLaborDailyValues(index);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </AccordionRow>

                <TotalRow
                  label="【L】計"
                  id="saleBudgetMonthData10"
                  color="lightBlue"
                  value={sumOfTotalEmployeeLaborCostAndPartLaborCost}
                />

                <PercentRow
                  id="saleBudgetMonthData10"
                  label="L率"
                  value={
                    sumOfTotalEmployeeLaborCostAndPartLaborCost > 0 && sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow > 0
                      ? sumOfTotalEmployeeLaborCostAndPartLaborCost / sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow
                      : 0
                  }
                />

                {/* End L（人件費） */}
                {/* Start A（広告費） */}
                <AccordionRow
                  isExpanded={isAdvertisingCostExpanded}
                  trigger={
                    <LabelRow
                      label="A（広告費）"
                      isExpanded={isAdvertisingCostExpanded}
                      handleClick={() => setIsAdvertisingCostExpand((prev) => !prev)}
                      color="lightBlue"
                      id="sumOfAdvertisingExpense"
                    />
                  }
                >
                  {monthLtAdvertising?.map((data, index) => (
                    <tr key={data.analyticalItemCode}>
                      <td colSpan={1} className="empty_column lightBlue" />
                      <td className="text-right active p-right" colSpan={3}>
                        <label className="control-label">{data.analyticalItemName}</label>
                      </td>
                      <td colSpan={1} className="column_change text-center">
                        {showExpensesClassificationText(data.expensesClassification)}
                      </td>
                      <td colSpan={1} className="text-right active width-110">
                        <InputCell
                          id={`monthLtAdvertising[${index}].dayTotal`}
                          value={data.dayTotal}
                          hasError={formik.errors.monthLtAdvertising?.[index]?.dayTotal}
                          disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtAdvertisingDailyValues(index);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </AccordionRow>

                <TotalRow
                  label="【A】計"
                  id="saleBudgetMonthData12"
                  color="lightBlue"
                  value={sumOfAdvertisingExpense}
                />

                <PercentRow
                  id="saleBudgetMonthData12"
                  label="A率"
                  value={
                    sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow > 0
                      ? sumOfAdvertisingExpense / sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow
                      : 0
                  }
                />

                {/* End A（広告費） */}
                {/* Start FLA合計*/}
                <tr>
                  <td colSpan={4} className="lightBlue p-left">
                    FLA合計
                  </td>
                  <td colSpan={1} className="column_change lightBlue" />
                  <td colSpan={1} className="text-right active width-110 lightBlue">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfAdvertisingExpense"
                    >
                      {sumOfFLACost.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4} className="p-left">
                    FLA率
                  </td>
                  <td colSpan={1} className="column_change text-center" />
                  <td colSpan={1} className="text-right active width-110 ">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfAdvertisingExpense"
                    >
                      {formatterPercent.format(sumOfFLACostRate)}
                    </span>
                  </td>
                </tr>
                {/* End FLA合計 */}
                {/* Start 店舗利益 */}
                <tr>
                  <td colSpan={4} className="lightYellow p-left">
                    店舗損益
                  </td>
                  <td colSpan={1} className="column_change lightYellow" />
                  <td colSpan={1} className="text-right active width-110 lightYellow">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfAdvertisingExpense"
                    >
                      {sumOfProfitLossCost.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="empty_column" colSpan={1} style={{ backgroundColor: '#fff2cc' }} />
                  <td colSpan={3} className="text-right p-right">
                    店舗損益率
                  </td>
                  <td colSpan={1} className="column_change text-center" />
                  <td colSpan={1} className="text-right active width-110 ">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfAdvertisingExpense"
                    >
                      {formatterPercent.format(sumOfProfitLossCostRate)}
                    </span>
                  </td>
                </tr>

                {/* End 店舗利益 */}
                {/* Start R（家賃） */}
                <AccordionRow
                  isExpanded={isRentExpanded}
                  trigger={
                    <LabelRow
                      label="R（家賃）"
                      isExpanded={isRentExpanded}
                      handleClick={() => setIsRentExpand((prev) => !prev)}
                      color="lightBlue"
                      id="sumOfAdvertisingExpense"
                    />
                  }
                >
                  {monthLtRent?.map((data, index) => (
                    <tr key={data.analyticalItemCode}>
                      <td colSpan={1} className="empty_column lightBlue" />
                      <td className="text-right active p-right" colSpan={3}>
                        <label className="control-label">{data.analyticalItemName}</label>
                      </td>
                      <td colSpan={1} className="column_change text-center">
                        {showExpensesClassificationText(data.expensesClassification)}
                      </td>
                      <td colSpan={1} className="text-right active width-110">
                        <InputCell
                          id={`monthLtRent[${index}].dayTotal`}
                          value={data.dayTotal}
                          hasError={formik.errors.monthLtRent?.[index]?.dayTotal}
                          disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtRentDailyValues(index);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </AccordionRow>

                <TotalRow label="【R】計" id="sumOfAdvertisingExpense" color="lightBlue" value={sumOfLandRentRow} />

                <PercentRow
                  id="sumOfAdvertisingExpense"
                  label="R率"
                  value={
                    sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow > 0
                      ? sumOfLandRentRow / sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow
                      : 0
                  }
                />

                {/* End R（家賃） */}
                {/* Start O（その他経費）*/}
                <AccordionRow
                  isExpanded={isOtherExpensesExpanded}
                  trigger={
                    <LabelRow
                      label="O（その他経費）"
                      isExpanded={isOtherExpensesExpanded}
                      handleClick={() => setIsOtherExpensesExpand((prev) => !prev)}
                      color="lightBlue"
                      id="sumOfTotalOtherVariableCostsAndOtherFixedCosts"
                    />
                  }
                >
                  {monthLtExpenses?.map((data, index) => (
                    <tr key={data.analyticalItemCode}>
                      <td colSpan={1} className="empty_column lightBlue" />
                      <td className="text-right active p-right" style={{ maxWidth: '160px' }} colSpan={3}>
                        <label className="control-label">{data.analyticalItemName}</label>
                      </td>
                      <td colSpan={1} className="column_change text-center">
                        {showExpensesClassificationText(data.expensesClassification)}
                      </td>
                      <td colSpan={1} className="text-right active width-110">
                        <InputCell
                          id={`monthLtExpenses[${index}].dayTotal`}
                          value={data.dayTotal}
                          hasError={formik.errors.monthLtExpenses?.[index]?.dayTotal}
                          disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtExpensesDailyValues(index);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </AccordionRow>

                <TotalRow
                  label="【O】計"
                  id="sumOfTotalOtherVariableCostsAndOtherFixedCosts"
                  color="lightBlue"
                  value={sumOfOtherTotalCost}
                />

                <PercentRow
                  id="sumOfTotalOtherVariableCostsAndOtherFixedCosts"
                  label="O率"
                  value={sumOfOtherTotalCostRate}
                />

                {/* End O（その他経費） */}
                {/* Start 集計外項目 */}
                <tr>
                  <td className="text-left active lightBlue p-left" colSpan={4}>
                    <label className="control-label">集計外項目</label>
                  </td>
                  <td colSpan={1} className="column_change text-center" />
                  <td colSpan={1} className="text-right active width-110">
                    <span className="sumOfOther" />
                  </td>
                </tr>
                {monthLtOther?.map((data, index) => (
                  <tr key={data.analyticalItemCode}>
                    <td colSpan={1} className="empty_column lightBlue" />
                    <td className="text-right active p-right" colSpan={3}>
                      <label className="control-label">{data.analyticalItemName}</label>
                    </td>
                    <td colSpan={1} className="column_change text-center">
                      {showExpensesClassificationText(data.expensesClassification)}
                    </td>
                    <td colSpan={1} className="text-right active width-110">
                      <InputCell
                        id={`monthLtOther[${index}].dayTotal`}
                        value={data.dayTotal}
                        hasError={formik.errors.monthLtOther?.[index]?.dayTotal}
                        disabled={data.budgetType !== BudgetType.MONTHLY_INPUT}
                        onChange={(id, value) => {
                          setFieldValue(id, value);
                          calcLtOtherDailyValues(index);
                        }}
                      />
                    </td>
                  </tr>
                ))}
                {/* End 集計外項目 */}
                {/* Start 【FLARO】合計 */}
                <tr>
                  <td className="text-left active lightPurple p-left" colSpan={4}>
                    【FLARO】合計
                  </td>
                  <td colSpan={1} className="column_change lightPurple" />
                  <td colSpan={1} className="text-right active width-110 lightPurple">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      className="sumOfTotalOtherVariableCostsAndOtherFixedCosts"
                    >
                      {sumOfFLAROCost.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-right active lightPurple p-right" colSpan={4}>
                    FLARO率
                  </td>
                  <td colSpan={1} className="column_change lightPurple" />
                  <td colSpan={1} className="text-right active width-110 lightPurple">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      className="sumOfTotalOtherVariableCostsAndOtherFixedCosts"
                    >
                      {formatterPercent.format(
                        sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow > 0
                          ? sumOfFLAROCost / sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow
                          : 0,
                      )}
                    </span>
                  </td>
                </tr>
                {/* End 【FLARO】合計 */}
                {/* Start 営業利益 */}

                <tr>
                  <td className="text-left active lightYellow p-left" colSpan={4}>
                    <label className="control-label">営業利益</label>
                  </td>
                  <td colSpan={1} className="column_change lightYellow" />
                  <td colSpan={1} className="text-right active width-110 lightYellow">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      className="totalOfOperatingIncome"
                    >
                      {totalOfOperatingIncome.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="lightYellow" colSpan={1} />
                  <td className="text-right active p-right" colSpan={3}>
                    営業利益率
                  </td>
                  <td colSpan={1} className="column_change text-center" />
                  <td colSpan={1} className="text-right active width-110">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="rateOfOperationIncome"
                    >
                      {formatterPercent.format(rateOfOperationIncome)}
                    </span>
                  </td>
                </tr>
                {/* End 営業利益 */}
              </tbody>
            </table>
          </div>
          {/* Table Left */}

          {/* Table Right */}
          <div
            id="contentRight"
            className="tabLeft"
            style={{
              width: 'calc(100% - 350px)',
              overflowX: 'auto',
            }}
            onScroll={eventScroll}
          >
            <div
              style={{
                width: `${rightTableWidth}px`,
              }}
            >
              <table
                className="table table-bordered table-striped table-condensed text-nowrap"
                style={{ width: `${rightTableWidth}px` }}
              >
                <tbody>
                  {/* Table Top */}
                  {/* Start 売上高 */}
                  <AccordionRow
                    isExpanded={isAdvertisingSaleDataExpanded}
                    trigger={
                      <tr onClick={() => setIsAdvertisingSaleDataExpand((prev) => !prev)}>
                        {salesPlanDailyDateData.map((_, index) => (
                          <td key={`sumOfAdvertisingSaleAndSaleBudgetFree${index}`} className="text-right ">
                            <span />
                          </td>
                        ))}
                      </tr>
                    }
                  >
                    {monthLtSales?.map((data, i) => (
                      <tr key={`monthLtSales[${i}].tr`}>
                        {data.dayAryList.map((dayItem, j) => (
                          <td
                            style={{
                              width: '105px',
                            }}
                            key={`monthLtSales[${i}].dayAryList[${j}].td`}
                            className="text-right"
                          >
                            <InputCell
                              id={`monthLtSales[${i}].dayAryList[${j}]`}
                              value={dayItem}
                              hasError={formik.errors.monthLtSales?.[i]?.dayAryList?.[j]}
                              disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                              onChange={(id, value) => {
                                setFieldValue(id, value);
                                calcLtSalesMonthlyValue(i);
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </AccordionRow>
                  <tr>
                    {listSumOfAdvertisingSaleAndSaleBudgetFree.map((salesTotal, index) => (
                      <td
                        key={`sumOfAdvertisingSaleAndSaleBudgetFree${index}`}
                        style={{
                          width: '105px',
                        }}
                        className="text-right lightOrange"
                      >
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {salesTotal.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>

                  {/* End 売上高 */}
                  {/* Start F（食材費） */}
                  <AccordionRow
                    isExpanded={isIngredientCostExpanded}
                    trigger={
                      <tr onClick={() => setIsIngredientCostExpand((prev) => !prev)}>
                        {listSumOfFoodCostAndDrinkCost.map((_, index) => (
                          <td key={`sumOfFoodCostAndDrinkCost${index}`} className="text-right ">
                            <span />
                          </td>
                        ))}
                      </tr>
                    }
                  >
                    {monthLtCost?.map((data, i) => (
                      <tr key={data.analyticalItemCode}>
                        {data.dayAryList.map((dayItem, j) => (
                          <td key={`monthLtCost[${i}].dayAryList[${j}].td`} className="text-right ">
                            <InputCell
                              id={`monthLtCost[${i}].dayAryList[${j}]`}
                              value={dayItem}
                              hasError={formik.errors.monthLtCost?.[i]?.dayAryList?.[j]}
                              disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                              onChange={(id, value) => {
                                setFieldValue(id, value);
                                calcLtCostMonthlyValue(i);
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </AccordionRow>
                  <tr>
                    {listSumOfFoodCostAndDrinkCost.map((value, index) => (
                      <td key={`sumOfFoodCostAndDrinkCost${index}`} className="text-right  lightBlue">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {value.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>

                  <tr>
                    {listSumOfFoodCostAndDrinkCost.map((value, index) => (
                      <td key={`sumOfFoodCostAndDrinkCost${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(
                            listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              ? value / listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              : 0,
                          )}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End F（食材費） */}

                  {/* Start L（人件費*/}
                  <AccordionRow
                    isExpanded={isLaborCostExpanded}
                    trigger={
                      <tr onClick={() => setIsLaborCostExpand((prev) => !prev)}>
                        {listSumOfEmployeeLaborCostAndPartLaborCost.map((_, index) => (
                          <td key={`sumOfEmployeeLaborCostAndPartLaborCost${index}`} className="text-right ">
                            <span />
                          </td>
                        ))}
                      </tr>
                    }
                  >
                    {monthLtLabor?.map((data, i) => (
                      <tr key={`monthLtCost[${i}]`}>
                        {data.dayAryList.map((dayItem, j) => (
                          <td key={`monthLtCost[${i}].dayAryList[${j}].td`} className="text-right ">
                            <InputCell
                              id={`monthLtLabor[${i}].dayAryList[${j}]`}
                              value={dayItem}
                              hasError={formik.errors.monthLtLabor?.[i]?.dayAryList?.[j]}
                              disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                              onChange={(id, value) => {
                                setFieldValue(id, value);
                                calcLtLaborMonthlyValue(i);
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </AccordionRow>
                  <tr>
                    {listSumOfEmployeeLaborCostAndPartLaborCost.map((sumOfEmployeeLaborCostAndPartLaborCost, index) => (
                      <td key={`sumOfEmployeeLaborCostAndPartLaborCost${index}`} className="text-right lightBlue">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {sumOfEmployeeLaborCostAndPartLaborCost.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listSumOfEmployeeLaborCostAndPartLaborCost.map((sumOfEmployeeLaborCostAndPartLaborCost, index) => (
                      <td key={`sumOfEmployeeLaborCostAndPartLaborCost${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(
                            listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              ? sumOfEmployeeLaborCostAndPartLaborCost /
                                  listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              : 0,
                          )}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End L（人件費）*/}
                  {/* Start A（広告費）*/}
                  <AccordionRow
                    isExpanded={isAdvertisingCostExpanded}
                    trigger={
                      <tr onClick={() => setIsAdvertisingCostExpand((prev) => !prev)}>
                        {listSumOfAdvertisingExpenseEachDay?.map((_, index) => (
                          <td key={`sumOfAdvertisingExpenseEach${index}`} className="text-right ">
                            <span />
                          </td>
                        ))}
                      </tr>
                    }
                  >
                    {monthLtAdvertising?.map((data, i) => (
                      <tr key={data.analyticalItemCode}>
                        {data.dayAryList.map((dayItem, j) => (
                          <td key={`monthLtAdvertising[${i}].dayAryList[${j}].td`} className="text-right ">
                            <InputCell
                              id={`monthLtAdvertising[${i}].dayAryList[${j}]`}
                              value={dayItem}
                              hasError={formik.errors.monthLtAdvertising?.[i]?.dayAryList?.[j]}
                              disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                              onChange={(id, value) => {
                                setFieldValue(id, value);
                                calcLtAdvertisingMonthlyValue(i);
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </AccordionRow>
                  <tr>
                    {listSumOfAdvertisingExpenseEachDay.map((sumOfAdvertisingExpenseEach, index) => (
                      <td key={`sumOfAdvertisingExpenseEach${index}`} className="text-right lightBlue">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {sumOfAdvertisingExpenseEach.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listSumOfAdvertisingExpenseEachDay.map((sumOfAdvertisingExpenseEach, index) => (
                      <td key={`sumOfAdvertisingExpenseEach${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(
                            listSumOfAdvertisingSaleAndSaleBudgetFree[index] > 0
                              ? sumOfAdvertisingExpenseEach / listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              : 0,
                          )}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End A（広告費） */}
                  {/* Start FLA合計 */}
                  <tr>
                    {listOfFLACost.map((fLACost, index) => (
                      <td key={`fLACost${index}`} className="text-right lightBlue">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {fLACost.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfFLACostRate.map((fLACostRate, index) => (
                      <td key={`fLACostRate${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(fLACostRate)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End FLA合計 */}
                  {/* Start 店舗利益*/}
                  <tr>
                    {listOfProfitLossCost.map((PLCost, index) => (
                      <td key={`fLACost${index}`} className="text-right lightYellow">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {PLCost.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfProfitLossCostRate.map((PLCostRate, index) => (
                      <td key={`fLACostRate${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(PLCostRate)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End 店舗利益 */}
                  {/* Start R（家賃）*/}
                  <AccordionRow
                    isExpanded={isRentExpanded}
                    trigger={
                      <tr onClick={() => setIsRentExpand((prev) => !prev)}>
                        {listOfFLACostRate.map((_, index) => (
                          <td key={`fLACostRate${index}`} className="text-right ">
                            <span />
                          </td>
                        ))}
                      </tr>
                    }
                  >
                    {monthLtRent?.map((data, i) => (
                      <tr key={data.analyticalItemId}>
                        {data.dayAryList.map((dayItem, j) => (
                          <td key={`monthLtRent[${i}].dayAryList[${j}].td`} className="text-right ">
                            <InputCell
                              id={`monthLtRent[${i}].dayAryList[${j}]`}
                              value={dayItem}
                              hasError={formik.errors.monthLtRent?.[i]?.dayAryList?.[j]}
                              disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                              onChange={(id, value) => {
                                setFieldValue(id, value);
                                calcLtRentMonthlyValue(i);
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </AccordionRow>
                  <tr>
                    {listSumOfRentEachDay.map((data, index) => (
                      <td key={`landRent${index}`} className="text-right lightBlue">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {data.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>

                  <tr>
                    {listSumOfRentEachDay.map((data, index) => (
                      <td key={`fLACostRate${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(
                            listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              ? data / listSumOfAdvertisingSaleAndSaleBudgetFree[index]
                              : 0,
                          )}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End R（家賃） */}
                  {/* Start O（その他経費） */}
                  <AccordionRow
                    isExpanded={isOtherExpensesExpanded}
                    trigger={
                      <tr onClick={() => setIsOtherExpensesExpand((prev) => !prev)}>
                        {listSumOfOtherTotalCost.map((_, index) => (
                          <td key={`sumOfOtherVariableCostsAndOtherFixedCosts${index}`} className="text-right ">
                            <span />
                          </td>
                        ))}
                      </tr>
                    }
                  >
                    <>
                      {monthLtExpenses?.map((data, i) => (
                        <tr key={data.analyticalItemId}>
                          {data.dayAryList.map((dayItem, j) => (
                            <td key={`monthLtExpenses[${i}].dayAryList[${j}].td`} className="text-right ">
                              <InputCell
                                id={`monthLtExpenses[${i}].dayAryList[${j}]`}
                                value={dayItem}
                                hasError={formik.errors.monthLtExpenses?.[i]?.dayAryList?.[j]}
                                //  disabled={
                                //   salesPlanDailyDateData[j].status === BusinessStatus.Closed ||
                                //   data.budgetType !== BudgetType.DAILY_INPUT
                                // }
                                disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                                onChange={(id, value) => {
                                  setFieldValue(id, value);
                                  calcLtExpensesMonthlyValue(i);
                                }}
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </>
                  </AccordionRow>
                  <tr>
                    {listSumOfOtherTotalCost.map((otherCost, index) => (
                      <td key={`otherCost${index}`} className="text-right lightBlue">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {otherCost.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>

                  <tr>
                    {listSumOfOtherTotalCostRate.map((otherCostRate, index) => (
                      <td key={`otherCostRate${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(otherCostRate)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End O（その他経費） */}
                  {/* Start 集計外項目 */}
                  <tr>
                    {salesPlanDailyDateData.map((_, index) => (
                      <td key={`otherDayAry${index}`} className="text-right ">
                        <span />
                      </td>
                    ))}
                  </tr>
                  {monthLtOther?.map((data, i) => (
                    <tr key={data.analyticalItemCode}>
                      {data.dayAryList.map((dayItem, j) => (
                        <td key={`monthLtOther[${i}].dayAryList[${j}].td`} className="text-right ">
                          <InputCell
                            id={`monthLtOther[${i}].dayAryList[${j}]`}
                            value={dayItem}
                            hasError={formik.errors.monthLtOther?.[i]?.dayAryList?.[j]}
                            disabled={data.budgetType !== BudgetType.DAILY_INPUT}
                            onChange={(id, value) => {
                              setFieldValue(id, value);
                              calcLtOtherMonthlyValue(i);
                            }}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}

                  {/* End 集計外項目 */}
                  <tr>
                    {listOfFLAROCost.map((fLAROCost, index) => (
                      <td key={`fLAROCost${index}`} className="text-right lightPurple">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {fLAROCost.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfFLAROCostRate.map((fLAROCostRate, index) => (
                      <td key={`fLAROCostRate${index}`} className="text-right lightPurple">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(fLAROCostRate)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* Start 営業利益 */}
                  <tr>
                    {listOfOperatingIncome.map((operatingIncome, index) => (
                      <td key={`operatingIncome${index}`} className="text-right lightYellow">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {operatingIncome.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfRateOperatingIncome.map((rateOperatingIncome, index) => (
                      <td key={`rateOperatingIncome${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(rateOperatingIncome)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* End 営業利益 */}
                  {/* Table Top */}
                </tbody>
              </table>
            </div>
          </div>
          {/* Table Right */}
        </div>
        {/* First Table */}
        {/* Second Table */}
        <div style={{ display: 'inline-flex', marginTop: 40, width: gridCol.grid12 }}>
          {/* Table Left */}
          <div className="layout_sale_left" style={{ width: '350px', borderRight: '5px solid rgb(210, 214, 222)' }}>
            <table
              id="salesBudgetMonth-BottomLeft"
              className="table table-bordered table-striped table-condensed text-nowrap"
            >
              <tbody>
                {/* Table Bottom */}
                <tr>
                  <td colSpan={2} className="text-right active p-right">
                    <label className="control-label">客単価</label>
                  </td>
                  <td style={{ width: '39px' }} className="column_change text-center" />
                  <td style={{ width: '105px' }} className="text-right active">
                    <InputCell
                      id="monthLtCustomPrice.dayTotal"
                      value={monthLtCustomPrice?.dayTotal ?? 0}
                      hasError={formik.errors.monthLtCustomPrice?.dayTotal}
                      // disabled={monthLtCustomPrice?.budgetType !== BudgetType.MONTHLY_INPUT}
                      disabled={true}
                      onChange={(id, value) => {
                        setFieldValue(id, value);
                        calcLtCustomPriceDailyValues();
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      客数&nbsp;
                      <IconTooltip iconType="help" text="売上高合計 / 客単価" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active ">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfNumberOfCustomers"
                    >
                      {sumOfNumberOfCustomers.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      回転率&nbsp;
                      <IconTooltip iconType="help" text="客数 / 座席数" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfTurnoverRate"
                    >
                      -
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '83px' }} className="text-center active" rowSpan={2}>
                    <label className="control-label">限界利益</label>
                  </td>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      額&nbsp;
                      <IconTooltip iconType="help" text="売上高合計 - 変動費" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfMarginalProfit"
                    >
                      {sumOfMarginalProfit.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      率&nbsp;
                      <IconTooltip iconType="help" text="限界利益 / 売上高合計の％表示" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfRateMarginalProfit"
                    >
                      {formatterPercent.format(sumOfRateMarginalProfit)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '83px' }} className="text-center active" rowSpan={2}>
                    <label className="control-label">貢献利益</label>
                  </td>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      額&nbsp;
                      <IconTooltip iconType="help" text="限界利益 - 固定費" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfContributionMargin"
                    >
                      {sumOfContributionMargin.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      率&nbsp;
                      <IconTooltip iconType="help" text="貢献利益 / 売上高合計の％表示" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfRateContributionMargin"
                    >
                      {formatterPercent.format(sumOfRateContributionMargin)}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{ width: '83px' }} className="text-center active" rowSpan={2}>
                    <label className="control-label">損益分岐点</label>
                  </td>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      売上&nbsp;
                      <IconTooltip iconType="help" text="固定費 / 限界利益率" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfBreakEventPointSale"
                    >
                      {sumOfBreakEventPointSale.toLocaleString()}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      客数&nbsp;
                      <IconTooltip iconType="help" text="損益分岐点売上 / 客単価" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '46px' }} className="column_change text-center" />
                  <td style={{ width: '87px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfBreakEventPointNumber"
                    >
                      {sumOfBreakEventPointNumber.toLocaleString()}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td
                    style={{ width: '83px' }}
                    className="text-center active"
                    rowSpan={monthLtLabor ? monthLtLabor.length + 1 : 1}
                  >
                    <label className="control-label">人件費率</label>
                  </td>
                  <td style={{ width: '117px' }} className="text-right active">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      合計&nbsp;
                      <IconTooltip iconType="help" text="人件費合計 / 売上高合計の％表示" color="#000" />
                    </div>
                  </td>
                  <td style={{ width: '39px' }} className="column_change text-center" />
                  <td style={{ width: '105px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfSumOfEmployeeAndPartCostRatio"
                    >
                      {formatterPercent.format(sumOfSumOfEmployeeAndPartCostRatio)}
                    </span>
                  </td>
                </tr>
                {/* render total of this collection */}
                {monthLtLabor?.map((data: BudgetDailyItemData) => (
                  <tr key={data.analyticalItemCode}>
                    <td
                      style={{
                        maxWidth: '117px',
                        whiteSpace: 'nowrap',
                      }}
                      className="text-right active"
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <label
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                          className="control-label"
                        >
                          {data.analyticalItemName.replace('人件費', '')}
                        </label>
                        &nbsp;
                        <IconTooltip
                          iconType="help"
                          text={`${data.analyticalItemName}/ 売上高合計の％表示`}
                          color="#000"
                        />
                      </div>
                    </td>
                    <td style={{ width: '39px' }} className="column_change text-center" />
                    <td style={{ width: '105px' }} className="text-right active">
                      <span
                        style={{
                          whiteSpace: 'normal',
                          display: 'inline-block',
                          maxWidth: '95px',
                          overflowWrap: 'break-word',
                        }}
                        id="sumOfEmployeeCostRatio"
                      >
                        {formatterPercent.format(
                          sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow > 0
                            ? data.dayTotal / sumOfAdvertisingSaleAndSumOfSaleBudgetFreeRow
                            : 0,
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td className="text-right active" colSpan={2}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                      }}
                    >
                      労働分配率&nbsp;
                      <IconTooltip
                        iconType="help"
                        text="人件費合計 /（売上高合計 - 食材費合計）の％表示"
                        color="#000"
                      />
                    </div>
                  </td>
                  <td style={{ width: '39px' }} className="column_change text-center" />
                  <td style={{ width: '105px' }} className="text-right active">
                    <span
                      style={{
                        whiteSpace: 'normal',
                        display: 'inline-block',
                        maxWidth: '95px',
                        overflowWrap: 'break-word',
                      }}
                      id="sumOfLaborShare"
                    >
                      {formatterPercent.format(sumOfLaborShare)}
                    </span>
                  </td>
                </tr>
              </tbody>
              {/* Table Bottom */}
            </table>
          </div>
          {/* Table Left */}

          {/* Table Right */}
          <div
            className="layout_sale_right_content1 hide_scrollbar_onscroll"
            id="contentRight2"
            style={{
              width: 'calc(100% - 350px)',
              overflowX: 'auto',
            }}
            onScroll={eventScroll}
          >
            <div
              style={{
                width: `${rightTableWidth}px`,
              }}
            >
              <table
                id="salesBudgetMonth-BottomRight"
                className="table table-bordered table-striped table-condensed text-nowrap"
                style={{ width: `${rightTableWidth}px` }}
              >
                <tbody>
                  {/* Table Bottom */}
                  <tr>
                    {monthLtCustomPrice?.dayAryList.map((dayItem, j) => (
                      <td
                        key={`monthLtCustomPrice.dayAryList[${j}].td`}
                        style={{
                          width: '105px',
                        }}
                        className="text-right "
                      >
                        <InputCell
                          id={`monthLtCustomPrice.dayAryList[${j}]`}
                          value={dayItem}
                          hasError={formik.errors.monthLtCustomPrice?.dayAryList[j]}
                          // disabled={monthLtCustomPrice?.budgetType !== BudgetType.DAILY_INPUT}
                          disabled={false}
                          onChange={(id, value) => {
                            setFieldValue(id, value);
                            calcLtCustomPriceMonthlyValue();
                          }}
                        />
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listNumberOfCustomers.map((numbersOfCustomers, index) => (
                      <td key={`numbersOfCustomers${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {numbersOfCustomers.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfTurnoverRate.map((turnoverRate, index) => (
                      <td key={`turnoverRate${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {turnoverRate.toFixed(2)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfMarginalProfit.map((marginalProfit, index) => (
                      <td key={`marginalProfit${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {marginalProfit.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listRateOfMarginalProfit.map((rateOfMarginalProfit, index) => (
                      <td key={`rateOfMarginalProfit${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(rateOfMarginalProfit)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfContributionMargin.map((contributionMargin, index) => (
                      <td key={`contributionMargin${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {contributionMargin.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfRateContributionMargin.map((rateContributionMargin, index) => (
                      <td key={`rateContributionMargin${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(rateContributionMargin)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfBreakEventPointSale.map((breakEventPointSale, index) => (
                      <td key={`breakEventPointSale${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {breakEventPointSale.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listOfBreakEventPointNumber.map((breakEventPointNumber, index) => (
                      <td key={`breakEventPointNumber${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {breakEventPointNumber.toLocaleString()}
                        </span>
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {listSumOfEmployeeAndPartCostRatio.map((sumOfEmployeeAndPartCostRatio, index) => (
                      <td key={`sumOfEmployeeAndPartCostRatio${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(sumOfEmployeeAndPartCostRatio)}
                        </span>
                      </td>
                    ))}
                  </tr>
                  {/* render total of this collection */}
                  {monthLtLabor?.map((data, index) => (
                    <tr key={data.analyticalItemCode}>
                      {data.dayAryList.map((dayItem, j) => (
                        <td key={`laborShare[${index}].[${j}]`} className="text-right ">
                          <span
                            style={{
                              whiteSpace: 'normal',
                              display: 'inline-block',
                              maxWidth: '95px',
                              overflowWrap: 'break-word',
                            }}
                          >
                            {formatterPercent.format(
                              listSumOfAdvertisingSaleAndSaleBudgetFree[j] > 0
                                ? dayItem / listSumOfAdvertisingSaleAndSaleBudgetFree[j]
                                : 0,
                            )}
                          </span>
                        </td>
                      ))}
                    </tr>
                  ))}
                  <tr>
                    {listOfLaborShare.map((laborShare, index) => (
                      <td key={`laborShare${index}`} className="text-right ">
                        <span
                          style={{
                            whiteSpace: 'normal',
                            display: 'inline-block',
                            maxWidth: '95px',
                            overflowWrap: 'break-word',
                          }}
                        >
                          {formatterPercent.format(laborShare)}
                        </span>
                      </td>
                    ))}
                  </tr>

                  {/* Table Bottom  */}
                </tbody>
              </table>
            </div>
          </div>
          {/* Table Right */}
        </div>
        {/* Second Table */}
      </div>
      {/* Table Body */}

      {/* Bottom scroll */}
      <div className="scroll-bottom-daily-settings" onScroll={eventScroll}>
        <div style={{ width: '350px', float: 'left' }} />
        <div
          style={{
            width: 'calc(100% - 350px)',
            float: 'right',
            height: '15px',
            overflow: 'auto',
          }}
          id="layout_sale_right_4"
        >
          <div className="scroll" id="layout_sale_right_5" style={{ width: `${rightTableWidth}px` }} />
        </div>
      </div>
      {/* Bottom scroll */}
    </div>
  );
};
export default TableSalesPlanDaily;
